import { Link } from 'react-router';
import React from 'react';
import { Page, Row } from 'shared/containers/portal_layout';
import styles from 'agent_portal/components/OrganizationSettingsPage/EntitySettings/EntitySettings.module.scss';
import cx from 'classnames';
import PropTypes from 'prop-types';

const NavLink = ({ to: path, label }, context) => (
  <li className={cx({ active: context.router.isActive(path) })}>
    <Link to={path}>{label}</Link>
  </li>
);

NavLink.contextTypes = { router: PropTypes.object };

const Main = props => (
  <Page title="Notifications">
    <Row>
      <div className={styles.container}>
        <div className={styles.nav_container}>
          <div className="well">
            <ul className="nav nav-list">
              <li className="nav-header">Notfications</li>
              <NavLink
                to={`/a/portal/passive_app_notifications/unread`}
                label="Unread Notifications"
              />
              <NavLink to={`/a/portal/passive_app_notifications/all`} label="All Notifications" />
            </ul>
          </div>
        </div>
        <div className={styles.content_container}>{props.children}</div>
      </div>
    </Row>
  </Page>
);

export default Main;
